import Col from 'react-bootstrap/Col';
import './style.css';
import clsx from 'clsx';

interface Props extends React.PropsWithChildren {
    isActive?: boolean;
    hasEvent?: boolean;
    onClick?: () => void;
}

const Cell: React.FC<Props> = ({ onClick, children, isActive = false, hasEvent }) => {
    return (
        <Col onClick={!isActive ? onClick : undefined} className="col-md-1">
            <div
            title={hasEvent?"Kliknij w zaznaczony dzień i zobacz szczegóły":""}
                className={clsx({
                    'cell__has-event': hasEvent,
                    'cell__no-event': !hasEvent,
                })}
            >
                {children}
            </div>
        </Col>
    );
};

export default Cell;
